// eslint-disable-next-line no-shadow
export enum LocationGroups {
  NONE = 'None',
  UK = 'UK',
  Netherlands = 'Netherlands'
}
